/**
 * RESPONSIBILITY: match a theme to the band that draws it.
 *
 * A lookup and not a `switch`, for the reason the renderer registry exists: teaching the
 * page a new theme is adding a key here and a file beside it. A theme with no entry draws
 * nothing rather than throwing — a page saved with a theme this build has never heard of
 * is a deployment mid-flight, not a reason to show a visitor a blank screen.
 */
import { THEME } from '@app/sections';
import type { BandProps } from './kind';
import { Facts } from './Facts';
import { Body } from './Body';
import { Note } from './Note';
import { Schedule } from './Schedule';
import { Contacts } from './Contacts';
import { Questions } from './Questions';
import { Gallery } from './Gallery';
import { Video } from './Video';
import { Cta } from './Cta';
import { Location } from './Location';
import { Related } from './Related';
import { Elsewhere } from './Elsewhere';
import { Banner } from './Banner';

export type Band = (p: BandProps) => JSX.Element | null;

const BANDS: Record<string, Band> = {
  [THEME.Facts]: Facts,
  [THEME.Body]: Body,
  [THEME.Note]: Note,
  [THEME.Schedule]: Schedule,
  [THEME.Contacts]: Contacts,
  [THEME.Questions]: Questions,
  [THEME.Gallery]: Gallery,
  [THEME.Video]: Video,
  [THEME.Cta]: Cta,
  [THEME.Location]: Location,
  [THEME.Related]: Related,
  [THEME.Elsewhere]: Elsewhere,
  [THEME.Banner]: Banner,
};

export const bandFor = (theme: string | undefined): Band | undefined =>
  (theme ? BANDS[theme] : undefined);

export type { BandProps } from './kind';
